'use client';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Link } from 'next-view-transitions';

export default function NavItems() {
  const navItems = [
    {
      label: 'For Creatives',
      links: [
        { href: '/jobs', text: 'Jobs' },
        { href: '/bounties', text: 'Bounties' },
        { href: '/jobs/companies', text: 'Companies' },
        { href: '/community', text: 'Community' },
        { href: '/creatives', text: 'Profiles' },
      ],
    },
    {
      label: 'For Business',
      links: [
        { href: '/access', text: 'Access' },
        { href: '/turbo', text: 'Turbo' },
        { href: '/connect', text: 'Connect' },
        { href: '/contact-us', text: 'Contact us' },
        { href: '/jobs/new', text: 'Post a Job' },
      ],
    },
    {
      label: 'For Everyone',
      links: [
        { href: '/blog', text: 'Blog' },
        { href: '/tools', text: 'Tools' },
        { href: '/about', text: 'About us' },
        { href: '/resources', text: 'Resources' },
        { href: '/newsletter', text: 'Newsletter' },
      ],
    },
  ];

  return (
    <nav
      suppressHydrationWarning
      className="flex place-content-center items-center gap-6 text-sm font-bold"
    >
      {navItems.map((item, index) => (
        <div key={index}>
          <TooltipProvider>
            <Tooltip delayDuration={250}>
              <TooltipTrigger>
                <div className="hover:bg-accent hover:text-accent-foreground flex h-10 place-content-center items-center space-x-3 rounded-md px-4 py-4">
                  <span className="font-sans text-base font-semibold tracking-wide">
                    {item.label}
                  </span>
                </div>
              </TooltipTrigger>
              <TooltipContent className="border-border/50 bg-background mt-2 w-64 rounded-md border shadow-none">
                {item.links.map((link, linkIndex) => (
                  <div key={linkIndex}>
                    <Button
                      className="group w-full rounded-md"
                      variant="ghost"
                      asChild
                    >
                      <Link
                        className="text-foreground flex justify-start space-x-2"
                        href={link.href}
                      >
                        <span className="font-sans text-base font-semibold">
                          {link.text}
                        </span>
                      </Link>
                    </Button>
                  </div>
                ))}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      ))}
    </nav>
  );
}
